export enum ChartEditorError {
  WIDGET = 'WIDGET',
}
